/** Whether a viz fetch effect should no-op.

 *  Public share paints persisted cubes and must not re-solve when they exist.
 *  Shares saved before viz_json (or after Compute without a doc-dirty save)
 *  have no cube — those still fetch so the Sound pressure slider/legend work.
 *  Owner advanced mode holds the last field until Scan (`!vizGateOk`). */
export function shouldHoldVizFetch(opts: {
  readOnly: boolean;
  hasPersisted: boolean;
  vizGateOk: boolean;
  /** Display precomputed data or nothing — never reach the solver.
   *
   *  `readOnly` alone is not enough: it still fetches when a layer has no
   *  persisted cube, which is right for a public share (the note above) and
   *  wrong for the marketing showcase, whose bundles are deliberately trimmed
   *  to the ONE layer each room paints. Every other layer looks "missing"
   *  there, so read-only alone had the landing page POSTing a solve job to
   *  /api/admin/jobs for every visitor. */
  neverFetch?: boolean;
}): boolean {
  if (opts.neverFetch) return true;
  if (opts.readOnly) return opts.hasPersisted;
  return !opts.vizGateOk;
}
